import sortBy from 'lodash.sortby';

const stops = [
  {
    order: 1,
    titleEn: 'Intro',
    titleEs: 'Introducción',
    audioFile: 'intro',
  },
  {
    order: 3,
    titleEn: 'Timeline',
    titleEs: 'Cronología',
    audioFile: 'timeline',
  },
  {
    order: 10,
    titleEn: 'Continental Drift Game',
    titleEs: 'El juego de la deriva continental',
    audioFile: 'continental-drift-game',
  },
  {
    order: 2,
    titleEn: 'Touch Table',
    titleEs: 'Mesa táctil',
    audioFile: 'touch-table',
  },
  {
    order: 16,
    titleEn: 'Sauropod video',
    titleEs: 'Video del Saurópodo',
    audioFile: 'sauropod-video',
  },
  {
    order: 11,
    titleEn: 'Malawisaurus',
    titleEs: 'El Malawisaurus',
    audioFile: 'malawisaurus',
  },
  {
    order: 12,
    titleEn: 'Suchomimus',
    titleEs: 'El Suchomimus',
    audioFile: 'suchomimus',
  },
  {
    order: 9,
    titleEn: 'Ouranosaurus',
    titleEs: 'El Ouranosaurus',
    audioFile: 'ouranosaurus',
  },
  {
    order: 6,
    titleEn: 'Majungasaurus',
    titleEs: 'El Majungasaurus',
    audioFile: 'majungasaurus',
  },
  {
    order: 7,
    titleEn: 'Simosuchus',
    titleEs: 'El Simosuchus',
    audioFile: 'simosuchus',
  },
  {
    order: 8,
    titleEn: 'Masiakasaurus',
    titleEs: 'El Masiakasaurus',
    audioFile: 'masiakasaurus',
  },
  {
    order: 5,
    titleEn: 'Rapetosaurus',
    titleEs: 'El Rapetosaurus',
    audioFile: 'rapetosaurus',
  },
  {
    order: 4,
    titleEn: 'Rahonavis',
    titleEs: 'El Rahonavis',
    audioFile: 'rahonavis',
  },
  {
    order: 17,
    titleEn: 'Buitreraptor',
    titleEs: 'El Buitreraptor',
    audioFile: 'buitreraptor',
  },
  {
    order: 15,
    titleEn: 'Austroraptor',
    titleEs: 'El Austroraptor',
    audioFile: 'austroraptor',
  },
  {
    order: 14,
    titleEn: 'Pterosaur video',
    titleEs: 'Video del Pterosaurio',
    audioFile: 'pterosaur-video',
  },
  {
    order: 19,
    titleEn: 'Amargasaurus',
    titleEs: 'El Amargasaurus',
    audioFile: 'amargasaurus',
  },
  {
    order: 18,
    titleEn: 'Carnotaurus',
    titleEs: 'El Carnotaurus',
    audioFile: 'carnotaurus',
  },
  {
    order: 13,
    titleEn: 'Giganotosaurus',
    titleEs: 'El Giganotosaurus',
    audioFile: 'giganotosaurus',
  },
  {
    order: 20,
    titleEn: 'End Panel',
    titleEs: 'Final del Panel',
    audioFile: 'end',
  },
];

const sortedStops = sortBy(stops, [item => item.order]);

export default sortedStops;



// WEBPACK FOOTER //
// ./src/sortedStops.js